{
  "menu": {
    "description": "Coordinator menu",
    "items": [
      {
        "index": 0,
        "route": "",
        "href": "https://dev.portal.fixteamdrenthe.nl/login/sso",
        "label": "PORTAL",
        "icon": "open_in_new"
      },
      {
        "index": 0,
        "route": "content/coordinator/dashboard",
        "label": "DASHBOARD_COORDINATOR",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "content/coordinator/dashboard-statistics",
        "label": "DASHBOARD_STATISTICS_COORDINATOR",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "content/coordinator/all-questionnaires",
        "label": "QUESTIONNAIRES",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "request",
        "label": "CREATE_REQUEST",
        "icon": "arrow_forward"
      }
    ]
  }
}
